
//动态扩散圆
function ElectricArcMaterialProperty(options) {
    this._definitionChanged = new Cesium.Event();
    this._color = undefined; //颜色
    this._colorSubscription = undefined;

    this.color = options.color;
    this.speed = options.speed; //速度
}
Object.defineProperties(ElectricArcMaterialProperty.prototype, {
    isConstant: {
        get: function () {
            return false;
        }
    },
    definitionChanged: {
        get: function () {
            return this._definitionChanged;
        }
    },
    color: Cesium.createPropertyDescriptor('color'),
    speed: Cesium.createPropertyDescriptor('speed'),
});
ElectricArcMaterialProperty.prototype.getType = function (time) {
    return  Cesium.Material.ElectricArcMaterialType;
}
ElectricArcMaterialProperty.prototype.getValue = function (time, result) {
    if (!Cesium.defined(result)) {
        result = {};
    }
    //1、property 2、time 3、default 4、result
    result.color = Cesium.Property.getValueOrClonedDefault(this._color, time, Cesium.Color.RED, result.color);
     //1、property 2、time 3、default 4、result
    result.speed=Cesium.Property.getValueOrDefault(this.speed, time, 10, result.speed);
    return result;
}

ElectricArcMaterialProperty.prototype.equals = function (other) {
    return this === other ||
        (other instanceof ElectricArcMaterialProperty &&
            Cesium.Property.equals(this._color, other._color))
}


export default ElectricArcMaterialProperty;